import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full mb-5 whitespace-nowrap">
              <i className="ri-grid-line"></i>
              Browse by Category
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 text-balance">
              Popular Spreadsheet Categories
            </h2>
            <p className="text-base text-foreground-500 max-w-xl mx-auto">
              Explore curated product collections across all categories — from footwear to accessories
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/50 hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors duration-200">
                  <i className={`${cat.icon} text-xl text-primary-600`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800 text-center leading-tight whitespace-nowrap">
                  {cat.name}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}